import { render, staticRenderFns } from "./Social_Development.vue?vue&type=template&id=7088790e&scoped=true&"
import script from "./Social_Development.vue?vue&type=script&lang=js&"
export * from "./Social_Development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088790e",
  null
  
)

export default component.exports